<template>
  <div>
    <Header :userinfo="userInfo"></Header>
    <div class="container fix">
      <div class="navigation fix">
        <div class="breadcrumb">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>微课学习</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="book-select">
          当前选择教材：{{userInfo.bookInfo.bookName}}
          <span @click="changeBook">更换</span>
        </div>
      </div>
      <div class="banner"><img v-if="userInfo.bookInfo.versionId==6" src="@/assets/sz_list_banner.png" alt></div>
      <div class="slider">
        <div class="catalogue-tree">
          <div class="tree-title">教材目录</div>
          <div class="ui-scroll ctree" ref="catalist" @scroll="scrollCata">
            <el-tree :data="catalogues" ref="tree" :props="cataProps" node-key="catalogueId" :default-expanded-keys="[checkCatalogId]" accordion highlight-current @node-click="handleNodeClick">
              <span class="el-tree-node__label" slot-scope="{node}">
                <span :title="node.label">{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
      <div class="main">
        <div class="opts">
          <div class="opts-line fix">
            <div class="opts-title">本单元微课学习资源推荐：</div>
          </div>
        </div>
        <div ref="content" class="content ui-scroll" @scroll="scrollList">
          <div class="loaded" v-if="!loaded">资源加载中</div>
          <div v-else>
            <div class="null" v-if="resourceList.length === 0">
              <img src="@/assets/no_wrong.png" alt>
              <p>资源正在建设中</p>
            </div>
            <!-- 优质课例 -->
            <div class="resource-list" ref="source_1" v-if="resourceList.length > 0">
              <h3><i></i><span>微课学习</span></h3>
              <div class="resource-item fix" v-for="(item,index) in resourceList" :key="index">
                <div class="resource-cover">
                  <img :src="item.thumbImg||defaultImg[item.resourceTypeId+'-'+item.categoryId]">
                </div>
                <div class="resource-info">
                  <router-link class="link" :to="{path:'/microClass/detail', query:{resourceId: item.resourceId, resourceTypeId: item.resourceTypeId, categoryId: item.categoryId, resourceExtTypeId: item.resourceExtTypeId, catalogueId: item.catalogueId }}">
                    <p class="resource-title">{{item.title}}
                      <span class="title-tag" v-for="(tag, tagIndex) in item.tags" :key="tagIndex">{{tag}}</span>
                    </p>
                  </router-link>
                  <p class="resource-desc">
                    作者：{{item.author||"佚名"}}
                    <i class="division-line"></i>
                    更新时间：{{timeFormatter(item.updateTime)}}
                  </p>
                </div>
                <router-link :to="{path:'/microClass/detail', query:{resourceId: item.resourceId, resourceTypeId: item.resourceTypeId, categoryId: item.categoryId, resourceExtTypeId: item.resourceExtTypeId, catalogueId: item.catalogueId}}" class="resource-btn">预览</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="slogan">
        <span><em>·</em>深圳市“新课程 新课堂”单元教学资源包、录像课例获奖作品指定展示平台</span>
        <span><em>·</em>深圳市“演中学”课本剧剧本和录像获奖作品指定展示平台</span>
      </div>
      <SelectBookDialog ref="selectBook"></SelectBookDialog>
    </div>
    <Footer ref="footer"></Footer>
  </div>
</template>

<style scoped>
.container {
  position: relative;
  width: 960px;
  height: 800px;
  margin: 0 auto;
  background: #f5f5f5 url('../../assets/footer_bar.png') center bottom no-repeat;
  background-size: contain;
}
.navigation {
  padding-top: 20px;
  padding-bottom: 20px;
  font-size: 14px;
}
.navigation .breadcrumb {
  float: left;
  color: #aaa;
}
.navigation .book-select {
  float: right;
  color: #888;
}
.navigation .book-select span {
  margin-left: 10px;
  color: #FE793A;
  cursor: pointer;
}

.slider {
  width: 210px;
  float: left;
  margin-right: 15px;
}

.catalogue-tree {
  padding: 14px 8px 14px 14px;
  background-color: #fff;
}

.catalogue-tree .tree-title {
  position: relative;
  font-size: 16px;
  color: #333;
  font-weight: bold;
  padding-left: 16px;
  margin-bottom: 8px;
}

.catalogue-tree .tree-title::before {
  content: "";
  position: absolute;
  top: 2px;
  left: 0;
  height: 18px;
  width: 3px;
  background-color: #FE793A;
}
.catalogue-tree .ctree {
    height: 350px;
}

.el-tree >>> .el-tree-node__content {
  height: 40px;
  font-weight: bold;
}
.el-tree >>> .el-tree-node__content
.el-tree-node__expand-icon {
  padding: 0;
}
.el-tree >>> .el-tree-node__label {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 13px;
}

.el-tree
  >>> .el-tree-node__children
  .el-tree-node__content
  .is-leaf
  + .el-tree-node__label {
  font-weight: normal;
}

.el-tree--highlight-current
  >>> .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: #edf6ff;
  color: #FE793A;
}

.main {
  float: left;
  width: 735px;
  height: 525px;
  background: #fff;
  padding-top: 6px;
}

.opts .opts-line {
  font-size: 14px;
  margin: 0 10px;
  border-bottom: 1px solid #f5f5f5;
}

.opts .opts-title {
  float: left;
  line-height: 36px;
  margin-right: 8px;
  font-weight: bold;
}

.opts .opts-body {
  float: left;
  width: 735px;
}

.content {
  position: relative;
  height: 495px;
}

.content .null {
  position: absolute;
  top: 30%;
  left: 50%;
  width: 120px;
  margin-left: -60px;
}

.content .null img {
  margin: 0 auto;
  display: block;
  width: 60px;
  height: 60px;
}

.content .null p {
  margin: 8px 0;
  color: #ccc;
  font-size: 14px;
  text-align: center;
}

.content .loaded {
  position: absolute;
  top: 30%;
  left: 0;
  width: 100%;
  font-size: 14px;
  color: #999;
  text-align: center;
}

.content .resource-list {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f5f5f5;
}

.content .resource-list:first-child {
  border-top: none;
  padding-top: 0;
}

.content .resource-list h3 {
  display: flex;
  align-items: center;
  font-size: 14px;
  padding-left: 10px;
  margin-bottom: 10px;
}

.content .resource-list h3 i {
  width: 2px;
  height: 14px;
  background: #FE793A;
  margin-right: 7px;
}

.resource-list .nodata {
  text-align: center;
  font-size: 14px;
  color: #ccc;
  padding: 10px 0;
  margin-bottom: 40px;
}

.content .resource-item {
  position: relative;
  padding: 10px;
  background-color: #fff;
  border-bottom: 1px solid #f5f5f5;
}

.content .resource-item:last-child {
  border-bottom: none;
}

.content .resource-item .resource-cover {
  float: left;
  margin-right: 10px;
  width: 124px;
  height: 79px;
}
.content .resource-item .resource-cover img {
  width: 124px;
  height: 79px;
}

.content .resource-item .resource-info {
  float: left;
  height: 70px;
}

.content .resource-item .resource-title {
  width: 500px;
  line-height: 3.2;
  font-size: 14px;
  color: #333;
  font-weight: bold;
  margin: 0;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content .resource-item .resource-title:hover {
  color: #FE793A;
}

.content .resource-item .resource-title .title-tag{
  font-size: 12px;
  display: inline-block;
  border-radius: 2px;
  border: 1px solid #FE793A;
  color: #FE793A;
  padding: 2px 4px;
  height: 14px;
  line-height: 14px;
  margin-left: 8px;
  font-weight: normal;
}

.content .resource-item .resource-title .title-tag:hover{
  color: #FE793A;
}

.content .resource-item .resource-desc {
  width: 500px;
  line-height: 2.2;
  font-size: 12px;
  color: #888;
  margin: 0;
  padding: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.content .resource-item .resource-btn {
  float: right;
  display: block;
  margin: 30px 10px 0 0;
  font-size: 14px;
  text-decoration: none;
  color: #FE793A;
}

.slogan {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 960px;
  line-height: 55px;
  font-size: 13px;
  color: #555;
  text-align: center;
}
.slogan span:first-child {
  margin-right: 30px;
}
.slogan span em {
  margin-right: 10px;
}

.division-line {
  display: inline-block;
  margin: 0 4px;
  height: 16px;
  width: 2px;
  background-color: #ccc;
  vertical-align: -3px;
}

.link {
  text-decoration: none;
}
.banner {
  display: block;
  width: 960px;
  margin-bottom: 20px;
}
.banner img {
  width: 100%;
}
</style>

<script>
import api from '../../utils/api'
import moment from 'moment'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import SelectBookDialog from '@/components/SelectBookDialog'
import { Loading } from 'element-ui'
export default {
  data () {
    return {
      userInfo: {},
      listHeight: 530,
      loaded: false,
      resourceTypes: [],
      catalogues: [],
      checkResourceTypeId: 0, // 资源类型id
      checkResourceExtTypeId: 0, // 教辅资源id
      resourceList: [],
      teachList: [], // 教学资源包
      qualityClass: [], // 优质课例
      bookVideo: [], // 课本剧作品
      checkCatalogId: 0,
      checkCategoryId: 0, // 资源分类  1 = 优质课例，2 = 数字教辅授课资源
      pageContext: {}, // 分页上下文
      hasMore: true,
      cataProps: {
        label: 'catalogueName',
        children: 'children'
      },
      checkTypeRadio: '',
      defaultImg: {
        '3-2': require('@/assets/icon-teach.png'),
        '1-2': require('@/assets/icon-ppt.png'),
        '2-2': require('@/assets/icon-cartoon.png'),
        '1-1': require('@/assets/icon-lesson.png'),
        '2-1': require('@/assets/icon-textbook.png'),
        '4-2': require('@/assets/icon-draw.png'),
        '5-2': require('@/assets/icon-song.png'),
        '6-2': require('@/assets/icon-movie.png'),
        '7-2': require('@/assets/icon-english.png')
      },
      checkCatalogValues: [0],
      checkBookId: 0
    }
  },
  components: { Header, Footer, SelectBookDialog },
  created () {
    let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    let params = this.$route.params
    this.checkCategoryId = params.categoryId
    this.checkResourceTypeId = params.resourceTypeId
    this.checkTypeRadio = params.resourceTypeId + '-' + params.categoryId + '-' + params.resourceExtTypeId
    this.checkResourceExtTypeId = params.resourceExtTypeId
    this.pageContext = {}
    this.checkBookId = userInfo.bookInfo.bookId
    this.searchParams = {
      categoryId: this.checkCategoryId,
      resourceTypeId: this.checkResourceTypeId,
      resourceExtTypeId: this.checkResourceExtTypeId,
      catalogueId: this.checkCatalogId,
      bookId: this.checkBookId,
      pageContext: this.pageContext
    }
    // console.log(this.searchParams)
    this.userInfo = userInfo
    this.dataInit()
  },
  mounted () {
    this.resizeList()
    window.sessionStorage.setItem('listScrolltop', 0)
    window.sessionStorage.setItem('cataScrolltop', 0)
  },
  updated () {
    this.resizeList()
  },
  beforeRouteLeave (to, from, next) {
    this.path = from.path
    this.bookId = this.checkBookId
    next()
  },
  activated: function () {
    let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
    if ((this.path && this.path !== this.$route.path) || this.bookId !== userInfo.bookInfo.bookId) {
      let params = this.$route.params
      this.checkCategoryId = params.categoryId
      this.checkResourceTypeId = params.resourceTypeId
      this.checkTypeRadio = params.resourceTypeId + '-' + params.categoryId + '-' + params.resourceExtTypeId
      this.checkResourceExtTypeId = params.resourceExtTypeId
      this.pageContext = {}
      this.checkBookId = this.userInfo.bookInfo.bookId
      this.searchParams = {
        categoryId: this.checkCategoryId,
        resourceTypeId: this.checkResourceTypeId,
        resourceExtTypeId: this.checkResourceExtTypeId,
        catalogueId: this.checkCatalogId,
        bookId: this.checkBookId,
        pageContext: this.pageContext
      }
      this.dataInit()
      window.sessionStorage.setItem('listScrolltop', 0)
      window.sessionStorage.setItem('cataScrolltop', 0)
    }
    this.$refs.catalist.scrollTop = Number(window.sessionStorage.getItem('cataScrolltop'))
    this.$refs.content.scrollTop = Number(window.sessionStorage.getItem('listScrolltop'))
  },
  computed: {
    searchParams: {
      get () {
        return {
          categoryId: this.checkCategoryId,
          resourceTypeId: this.checkResourceTypeId,
          resourceExtTypeId: this.checkResourceExtTypeId,
          catalogueId: this.checkCatalogId,
          bookId: this.checkBookId,
          pageContext: this.pageContext
        }
      },
      set (newV) {}
    },
    getUserInfo () {
      return this.$store.state.userInfo
    }
  },
  watch: {
    getUserInfo (val) {
      this.userInfo = val
      this.pageContext = {}
      this.checkBookId = this.userInfo.bookInfo.bookId
      this.searchParams = {
        categoryId: this.checkCategoryId,
        resourceTypeId: this.checkResourceTypeId,
        resourceExtTypeId: this.checkResourceExtTypeId,
        catalogueId: this.checkCatalogId,
        bookId: this.checkBookId,
        pageContext: this.pageContext
      }
      this.dataInit()
      window.sessionStorage.setItem('listScrolltop', 0)
      window.sessionStorage.setItem('cataScrolltop', 0)
    }
  },
  methods: {
    dataInit () {
      this.getCatalogue()
      // await this.getResourceTypeList()
    },
    getCatalogue () {
      api.post('GetTeachResourceCatalogueRequest', {
        bookId: this.checkBookId
      }, res => {
        let catalogues = res.body.catalogues
        this.checkCatalogId = catalogues[0].catalogueId
        this.catalogTraveller(catalogues)
        this.catalogues = catalogues
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.checkCatalogId)
        })

        // 获取资源列表
        this.getResourceList()
      })
    },
    getResourceTypeList () {
      let loadingInstance = Loading.service()
      api.post('GetTeachResourceTypeRequest', {}, res => {
        this.resourceTypes = res.body.resourceTypes
        loadingInstance.close()
      })
    },
    getResourceList (isScroll) {
      if (isScroll && !this.hasMore) {
        return
      }
      let loadingInstance = Loading.service()
      api.post('GetTeachResourceListRequest', this.searchParams, res => {
        loadingInstance.close()
        let resourceList = res.body.resourceList
        this.loaded = true
        if (isScroll) {
          resourceList.forEach(element => {
            this.resourceList.push(element)
          })
        } else {
          // this.set('resourceList', resourceList)
          this.teachList = []
          this.qualityClass = []
          this.bookVideo = []
          for (let i = 0; i < resourceList.length; i++) {
            if (resourceList[i].resourceTypeId === 0) { // 教学资源包
              this.teachList.push(resourceList[i])
            } else if (resourceList[i].resourceTypeId === 1) { // 优质课例
              this.qualityClass.push(resourceList[i])
            } else { // 课本剧
              this.bookVideo.push(resourceList[i])
            }
          }
          this.resourceList = resourceList
        }
        this.pageContext = res.body.pageContext
        this.hasMore = res.body.hasMore
        this.setScrollPosition()
      })
    },
    checkResourceType () {
      this.checkResourceTypeId = this.checkTypeRadio.split('-')[0]
      this.checkCategoryId = this.checkTypeRadio.split('-')[1]
      this.checkResourceExtTypeId = this.checkTypeRadio.split('-')[2]
    },
    catalogueChange (e) {
      let checkCatalogValue = this.checkCatalogValues[this.checkCatalogValues.length - 1]
      this.checkCatalogId = checkCatalogValue
    },
    handleNodeClick (e) {
      this.checkCatalogId = e.catalogueId
      this.pageContext = {}
      this.getResourceList()
    },
    catalogTraveller (cata) {
      cata.forEach(element => {
        // element.value = element.catalogueId + '-' + element.catalogueName
        if (element.children.length === 0) {
          delete element.children
        } else {
          this.catalogTraveller(element.children)
        }
      })
    },
    changeBook () {
      this.$refs.selectBook.init()
    },
    timeFormatter (time) {
      return moment.unix(time).format('YYYY年MM月DD日')
    },
    scrollList (e) {
      let element = e.srcElement
      window.sessionStorage.setItem('listScrolltop', element.scrollTop)
      if (element.clientHeight + element.scrollTop === element.scrollHeight) {
        this.getResourceList(true)
      }
    },
    scrollCata (e) {
      let element = e.srcElement
      window.sessionStorage.setItem('cataScrolltop', element.scrollTop)
    },
    resizeList () {
      // let content = this.$refs.content
      // let footer = this.$refs.footer
      // this.listHeight = footer.$el.offsetTop - content.offsetTop - 20
    },
    // 进入页面初始化设置列表滚动条位置
    setScrollPosition () {
      let typeId = parseInt(this.$route.params.resourceTypeId)
      if (typeId === 0) {
        window.sessionStorage.setItem('listScrolltop', 0)
      } else if (typeId === 1) {
        let stop = Number(this.$refs.source_1.offsetTop)
        window.sessionStorage.setItem('listScrolltop', stop)
        this.$refs.content.scrollTop = stop
      } else {
        let stop = Number(this.$refs.source_5.offsetTop)
        window.sessionStorage.setItem('listScrolltop', stop)
        this.$refs.content.scrollTop = stop
      }
    }
  }
}
</script>
